
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import hyTranslation from './locales/hy/translation.json';
import ruTranslation from './locales/ru/translation.json';

import enManageBooking from './locales/en/manage-booking.json';
import hyManageBooking from './locales/hy/manage-booking.json';
import ruManageBooking from './locales/ru/manage-booking.json';

// Initialize i18next
i18n
  // Use language detector to automatically detect the user's language
  .use(LanguageDetector)
  // Connect with React
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
        manageBooking: enManageBooking
      },
      hy: {
        translation: hyTranslation,
        manageBooking: hyManageBooking
      },
      ru: {
        translation: ruTranslation,
        manageBooking: ruManageBooking
      }
    },
    fallbackLng: 'en', // Default language
    debug: process.env.NODE_ENV === 'development', // Set to true during development for debugging

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    
    // Add missing keys handling
    saveMissing: true,
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`Missing translation key: '${key}' for language: ${lng}`);
    }
  });

export default i18n;
